import { render, staticRenderFns } from "./RoomType.vue?vue&type=template&id=f8614444&"
import script from "./RoomType.vue?vue&type=script&lang=js&"
export * from "./RoomType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports